import { render, staticRenderFns } from "./NewsConfig.vue?vue&type=template&id=afefa2d0&scoped=true"
import script from "./NewsConfig.vue?vue&type=script&lang=js"
export * from "./NewsConfig.vue?vue&type=script&lang=js"
import style0 from "./NewsConfig.vue?vue&type=style&index=0&id=afefa2d0&prod&lang=scss"
import style1 from "./NewsConfig.vue?vue&type=style&index=1&id=afefa2d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afefa2d0",
  null
  
)

export default component.exports